import React, { useState, useEffect } from 'react'

import Grid from '@mui/material/Grid';

import RmvendorquotationFilterCriteria from './RmvendorquotationFilterCriteria'
import RmvendorquotationList from './RmvendorquotationList'
import MyPageContainer from '../../core/template/MyPageContainer';
import {getListAPI} from './RmvendorquotationAPI';
import {transformToCardFormat} from '../../core/js/FormUtils'
import {getPathVariable} from '../../core/js/UrlUtils';

import { useSearchParams } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import {setRmvendorquotationDashboardRmvendorquotationList } from '../../store/slice/PharmaSlice';

export default function RmvendorquotationListView({setShowEdit,setRmvendorquotationId}){
    const {filterCriteria} = useSelector((state)=>state.pharmaslice.rmvendorquotationDashboard);   

    const [filteredRmvendorquotationList, setFilteredRmvendorquotationList] = React.useState([]);
    const [cardList, setCardList] = useState([]);
    const [searchParams, setSearchParams] = useSearchParams();
    const { showfilter } = useSelector((state) => state.confslice);
    const { rmvendorquotationDashboard } = useSelector((state) => state.pharmaslice);
    
    function dataFetchCallBack(){
    }

    useEffect(()=>{
      if (rmvendorquotationDashboard.rmvendorquotationList.length>-1){
        setFilteredRmvendorquotationList(rmvendorquotationDashboard.rmvendorquotationList);
        transformToCardFormat(rmvendorquotationDashboard.rmvendorquotationList, setCardList);
      }
    },[rmvendorquotationDashboard.rmvendorquotationList])

    useEffect(()=>{
          transformToCardFormat(filteredRmvendorquotationList, setCardList);
      },[filteredRmvendorquotationList])

    useEffect(()=>{
        if (filterCriteria.rawdemandid==='' && filterCriteria.quotation==='' && filterCriteria.rmvendorid==='' && filterCriteria.rmvendorname==='' ){
            setFilteredRmvendorquotationList(rmvendorquotationDashboard.rmvendorquotationList);
            transformToCardFormat(rmvendorquotationDashboard.rmvendorquotationList, setCardList);

        } else {
            setFilteredRmvendorquotationList(
                rmvendorquotationDashboard.rmvendorquotationList
                    .filter(rmvendorquotation=> rmvendorquotation.rmvendorname.toString().toUpperCase().includes(filterCriteria.rmvendorname.toString().toUpperCase()))

                
            )
            

            //transformToCardFormat(rmvendorquotationDashboard.filteredRmvendorquotationList, setCardList);
        }
      },[filterCriteria])
  
     return(
        <Grid container direction="column" >
            <Grid item lg={12}>
                <RmvendorquotationList
                    setShowEdit={setShowEdit}
                    setRmvendorquotationId = {setRmvendorquotationId}
                    tableList={filteredRmvendorquotationList}
                    cardList={cardList}
                    />
          </Grid>
      </Grid>
    )
}